export default {
  subjectAdditionalTitle: 'Other:',
};
